import { ProposedActionStatus } from '../chat/types';

// A failed approval changed nothing; replying "Approved" leads Siesta to tell the user the change
// is live. The outcome message it receives explains why it failed. A suitability report card offers
// Review report and Dismiss rather than Approve and Deny, so its replies say so.
export const resumeMessageFor = (
  approve: boolean,
  status: ProposedActionStatus | undefined,
  isSuitabilityReport = false,
): string => {
  if (approve && status === 'FAILED') return 'Approved, but it could not be applied';
  if (isSuitabilityReport) return approve ? 'Reviewing the report' : 'Dismissed';
  return approve ? 'Approved' : 'Denied';
};
